import { Button, TextField, Typography, Modal, Box, Icon } from '@mui/material'
import { IGroupformData } from './interfaces'
import { ReactElement, useEffect, useState } from 'react'
import { addGroup, updateGroup } from '../../services/groupsServices'
import { IAddUserGroups } from './interfaces'
import { CloseOutlined } from '@mui/icons-material'
import theme from '../../theme/theme'
import { useTranslation } from 'react-i18next'
import { defaultFormData } from './constants'
import PaperModalComponent from '../Common/PaperModalComponent'

const AddGroup = (props: IAddUserGroups): ReactElement => {
    const { t } = useTranslation()
    const { openAddOrEditGroup, org, handleAddOrEditGroup } = props
    const { open, mode, formData: data } = openAddOrEditGroup

    const [formValues, setFormValues] = useState<IGroupformData>({ ...data })
    const [errors, setErrors] = useState<{
        name?: string
        description?: string
    }>({}) // Provide optional types for error messages
    const [isUpdated, setIsUpdated] = useState<boolean>(true)

    useEffect(() => {
        if (
            formValues.name === data.name &&
            formValues.description === data.description &&
            mode !== 'Add'
        ) {
            setIsUpdated(false)
        } else {
            setIsUpdated(true)
        }
    }, [formValues])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setFormValues({
            ...formValues,
            [name]: value,
        })

        // Clear errors when user starts typing
        setErrors({
            ...errors,
            [name]: '',
        })
    }

    const validateForm = () => {
        const { name } = formValues
        const errors: { name?: string; description?: string } = {} // Provide optional types for error messages
        if (!name.trim()) {
            errors.name = t('nameRequired')
        }

        // if (!description.trim()) {
        //     errors.description = 'Description is required'
        // }
        setErrors(errors)
        return Object.keys(errors).length === 0
    }

    const clearForm = () => {
        setFormValues(defaultFormData)
        setErrors({})
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        if (validateForm()) {
            if (mode === 'Add') {
                await addGroup(formValues, org.id)
            } else {
                await updateGroup(formValues, org.id)
            }

            // handleClose()
            clearForm()
            handleAddOrEditGroup(true)
        }
    }

    return (
        <div>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <PaperModalComponent>
                    <form onSubmit={handleSubmit}>
                        <Box
                            sx={{
                                p: 4,
                                boxShadow: 4,
                                borderRadius: 4,
                                position: 'absolute' as const,
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                backgroundColor: '#fff',
                                border: `2px solid ${theme.palette.primary.main}`,
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '15px',
                                    cursor: 'pointer',
                                }}
                            >
                                <Icon
                                    onClick={() => handleAddOrEditGroup(false)}
                                    sx={{ marginRight: '8px' }}
                                    fontSize="small"
                                    id="add-group-close-icon"
                                >
                                    <CloseOutlined
                                        sx={{
                                            color: '#000',
                                            marginTop: '-2px',
                                        }}
                                    />
                                </Icon>
                            </Box>
                            <Typography
                                variant="h6"
                                gutterBottom
                                component="h2"
                                id="draggable-modal-title"
                                sx={{ cursor: 'move' }}
                            >
                                {mode === 'Edit'
                                    ? t('editUserGroup')
                                    : t('addUserGroup')}
                            </Typography>
                            <Box sx={{ mt: 2 }}>
                                <TextField
                                    id="add-group-name"
                                    name="name"
                                    label={t('nameMust')}
                                    variant="outlined"
                                    type="text"
                                    value={formValues.name}
                                    onChange={handleInputChange}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    fullWidth
                                />
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <TextField
                                    id="add-group-description"
                                    name="description"
                                    label={t('description')}
                                    type="text"
                                    value={formValues.description}
                                    onChange={handleInputChange}
                                    error={!!errors.description}
                                    helperText={errors.description}
                                    fullWidth
                                />
                            </Box>
                            <Button
                                sx={{
                                    mt: 2,
                                }}
                                variant="contained"
                                color="primary"
                                fullWidth
                                id="add-group-submit-button"
                                disabled={!isUpdated}
                                type="submit"
                            >
                                {t('submit')}
                            </Button>
                        </Box>
                    </form>
                </PaperModalComponent>
            </Modal>
        </div>
    )
}
export default AddGroup
